import { render } from "./ClientUploadsDialog.vue?vue&type=template&id=7c138dea&scoped=true"
import script from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClientUploadsDialog.vue?vue&type=style&index=0&id=7c138dea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c138dea"],['__file',"src/components/dialogs/ClientUploadsDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c138dea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c138dea', __exports__)) {
    api.reload('7c138dea', __exports__)
  }
  
  module.hot.accept("./ClientUploadsDialog.vue?vue&type=template&id=7c138dea&scoped=true", () => {
    api.rerender('7c138dea', render)
  })

}


export default __exports__